<template>
    <div class="library-published-status-filter" data-testid="library-published-status-filter">
        <CollapsibleWidget>
            <template #name>Publishing Status</template>

            <CheckboxGroup :model-value="[publishedStatusFilter]">
                <Checkbox
                    :label="PlatformPublishedStatusFilter.All"
                    @click.stop.prevent="setPublishedStatusFilter(PlatformPublishedStatusFilter.All)"
                >
                    All
                </Checkbox>
                <Checkbox
                    :label="PlatformPublishedStatusFilter.Published"
                    @click.stop.prevent="setPublishedStatusFilter(PlatformPublishedStatusFilter.Published)"
                >
                    Published
                </Checkbox>

                <div v-if="isPublishedSubmenuVisible" class="library-published-status-filter__sub-group">
                    <Checkbox
                        :label="PlatformPublishedStatusFilter.PublishedToDoubleClick"
                        @click.stop.prevent="
                            setPublishedStatusFilter(PlatformPublishedStatusFilter.PublishedToDoubleClick)
                        "
                    >
                        {{ PlatformLabel[PLATFORM.DOUBLECLICK] }}
                    </Checkbox>
                    <Checkbox
                        :label="PlatformPublishedStatusFilter.PublishedToOpenDC"
                        @click.stop.prevent="setPublishedStatusFilter(PlatformPublishedStatusFilter.PublishedToOpenDC)"
                    >
                        {{ PlatformLabel[PLATFORM.OPENDC] }}
                    </Checkbox>
                </div>

                <Checkbox
                    :label="PlatformPublishedStatusFilter.NotPublished"
                    @click.stop.prevent="setPublishedStatusFilter(PlatformPublishedStatusFilter.NotPublished)"
                >
                    Not published
                </Checkbox>
                <div v-if="isNotPublishedSubmenuVisible" class="library-published-status-filter__sub-group">
                    <Checkbox
                        :label="PlatformPublishedStatusFilter.NotPublishedToDoubleClick"
                        @click.stop.prevent="
                            setPublishedStatusFilter(PlatformPublishedStatusFilter.NotPublishedToDoubleClick)
                        "
                    >
                        {{ PlatformLabel[PLATFORM.DOUBLECLICK] }}
                    </Checkbox>
                    <Checkbox
                        :label="PlatformPublishedStatusFilter.NotPublishedToOpenDC"
                        @click.stop.prevent="
                            setPublishedStatusFilter(PlatformPublishedStatusFilter.NotPublishedToOpenDC)
                        "
                    >
                        {{ PlatformLabel[PLATFORM.OPENDC] }}
                    </Checkbox>
                </div>
            </CheckboxGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts">
import { PLATFORM } from "hoxton-shared/enums/exports";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { PlatformLabel, PlatformPublishedStatusFilter } from "@/enums/platforms";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";

export default {
    components: {
        CollapsibleWidget
    },

    data() {
        return {
            PLATFORM,
            PlatformLabel,
            PlatformPublishedStatusFilter,
            publishedFilterStatuses: [] as string[],
            notPublishedFilterStatuses: [] as string[]
        };
    },

    computed: {
        isPublishedSubmenuVisible() {
            return this.publishedFilterStatuses.includes(this.publishedStatusFilter);
        },

        isNotPublishedSubmenuVisible() {
            return this.notPublishedFilterStatuses.includes(this.publishedStatusFilter);
        },

        publishedStatusFilter: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.publishedStatusFilter];
            },
            set(value: (typeof PlatformPublishedStatusFilter)[keyof typeof PlatformPublishedStatusFilter]) {
                this.$store.dispatch(DeliverableLibraryAction.UpdatePublishedStatusFilter, value);
            }
        }
    },
    created() {
        this.publishedFilterStatuses = [
            PlatformPublishedStatusFilter.Published,
            PlatformPublishedStatusFilter.PublishedToDoubleClick,
            PlatformPublishedStatusFilter.PublishedToOpenDC
        ];
        this.notPublishedFilterStatuses = [
            PlatformPublishedStatusFilter.NotPublished,
            PlatformPublishedStatusFilter.NotPublishedToDoubleClick,
            PlatformPublishedStatusFilter.NotPublishedToOpenDC
        ];
    },

    methods: {
        setPublishedStatusFilter(
            publishedStatus: (typeof PlatformPublishedStatusFilter)[keyof typeof PlatformPublishedStatusFilter]
        ) {
            this.publishedStatusFilter = publishedStatus;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-published-status-filter__sub-group {
    margin: 0 0 $spacing-smaller $spacing;
    padding: $spacing-smaller 0;
}
</style>
